import { Translatable } from "@icc/shared/helpers";

export class RollerGuideDrilling {
    id: number;
    code: string;
    @Translatable({ model: 'GuideDrillingOptions' })
    name: string;
    img: null | string;
    default?: boolean;
    changed?: boolean;
}

export interface IccRollerGuideDrilling {
    id: number;
    code: string;
    name: string;
    img: null | string;
}
